/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_Form_DescriptionInputs */



/**
* | output |
* | --- |
* | "Define a named AI persona with a system prompt that shapes how the AI behaves." |
*
* @param {Personas_Form_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_form_description = /** @type {((inputs?: Personas_Form_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Form_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Definieren Sie eine benannte KI-Persona mit einem System-Prompt, der das Verhalten der KI bestimmt.")
	return /** @type {LocalizedString} */ ("Define a named AI persona with a system prompt that shapes how the AI behaves.")
});